import React from 'react';

const LocuLogo = ({
  className = "h-8",
  showText = false,
  textSize = "text-xl",
  variant = "default" // "default" (purple), "white", "dark"
}) => {
  const textColor = variant === "white" ? "text-white" : variant === "dark" ? "text-gray-900" : "text-purple-700";

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src="/logo.png"
        alt="LOCU"
        className="h-full w-auto flex-shrink-0"
        style={variant === "white" ? { filter: "brightness(0) invert(1)" } : variant === "dark" ? { filter: "brightness(0)" } : {}}
      />
      {showText && (
        <span className={`font-bold ${textSize} ${textColor} tracking-tight`}>
          LOCU
        </span>
      )}
    </div>
  );
};

// Icon-only version
export const LocuLogoIcon = ({ size = 32, variant = "default" }) => {
  return (
    <img
      src="/logo.png"
      alt="LOCU"
      width={size}
      height={size}
      style={variant === "white" ? { filter: "brightness(0) invert(1)" } : variant === "dark" ? { filter: "brightness(0)" } : {}}
    />
  );
};

// Full logo with text
export const LocuLogoFull = ({ className = "h-10", variant = "default" }) => {
  const textColor = variant === "white" ? "text-white" : variant === "dark" ? "text-gray-900" : "text-purple-600";

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src="/logo.png"
        alt="LOCU"
        className="h-full w-auto"
        style={variant === "white" ? { filter: "brightness(0) invert(1)" } : variant === "dark" ? { filter: "brightness(0)" } : {}}
      />
      <span className={`font-bold text-2xl ${textColor} tracking-tight`}>
        LOCU
      </span>
    </div>
  );
};

export default LocuLogo;
